/* eslint-disable */
import moment from 'moment';
import momentTz from 'moment-timezone';
import axios from "axios";
import NotificationManager from '../../components/Notifications/NotificationManager';
import { convertSecondsToTime } from 'Components/Map/utils';
import { formatRelativeTimeText } from './relativeTime';

export const getDataForEntityTags = (entity, drivers, units, subusers, forms, landmarks, geofences, assets, additionalParams) => {
	let data = [];
	if (entity === "Driver") {
		data = drivers.map(d => {
			return { id: d.driverId, name: "Driver", label: d.name, status: d.status }
		});
	} else if (entity === "Unit") {
		data = units.map(d => {
			return { id: d.id, name: "Unit", label: d.label, unitVersionId: d.unitVersionId, jbus: d.jbus, vbus: d.vbus }
		});
		if (additionalParams?.unitsIds) {
			const unitIds = additionalParams.unitsIds?.items?.map(m => m.unitId);
			if (unitIds) {
				data = data.filter((item) => (unitIds.includes(item.id)));
			}
		}
	} else if (entity === "User") {
		data = subusers?.items?.map(d => {
			return { id: `${d.id}`, name: "User", label: d.userName }
		});
	} else if (entity === "Form") {
		data = forms?.map(f => {
			return { id: `${f.id}`, name: "Form", label: f.name }
		});
	} else if (entity === "Asset") {
		data = assets?.map(a => {
			return { id: `${a.id}`, name: "Asset", label: a.label }
		});
	} else if (entity === "Landmark") {
		data = landmarks?.map(d => {
			return { id: d.id, name: "Landmark", label: d.name }
		});
	} else if (entity === "Geofence") {
		data = geofences?.map(g => {
			return { id: g.id, name: "Geofence", label: g.name }
		});
	}
	return data;
}
export const getDeliveryAtFormat = (deliveryAt, frequency, deliveryOn, messages) => {
	let deliveryAtFormat = ''

	switch (frequency) {
		case 'daily':
			deliveryAtFormat = `${deliveryAt}`
			break;
		case 'weekly':
			const deliveryOnLanguage = deliveryOn.map((item) => messages[item])
			deliveryAtFormat = `${deliveryOnLanguage} ${messages["at"]} ${deliveryAt}`
			break;
		case 'monthly':
			deliveryAtFormat = `${messages["at"] === "at" ? deliveryOn : "El " + deliveryOn[0]?.replace(/[a-zA-Z]/g, "")} ${messages["at"]} ${deliveryAt}`
			break;
	}
	return deliveryAtFormat
}
export const speedFormatMPH = (speed, unitType, kph, isVehicleTrails = false, onlyNumber = false) => {
	if (!speed || speed == 0) {
		return `0 ${!onlyNumber ? (kph ? 'KPH' : 'MPH') : ""}`;
	}

	if (!isVehicleTrails) {
		speed = converSpeedToMph(speed, unitType);
	}
	if (kph) {
		speed = convertToKPH(speed);
		speed = Math.round(speed);
		if (!onlyNumber) { //default value in string with speed
			return `${speed} KPH`;
		} else {
			return speed;
		}
	} else {
		speed = Math.round(speed);
		if (!onlyNumber) { //default value in string with speed format
			return `${Math.ceil(speed)} MPH`;
		} else {
			return Math.ceil(speed);
		}
	}
}

export const deleteDupplyInArray = (array, nameProp) => {
	return array.filter((item, index, self) =>
		index === self.findIndex((t) => (
			t[nameProp] === item[nameProp]
		))
	);
}

export const postedSpeedColor = (speed, speedLimit) => {
	if (!speed || !speedLimit) return '#000000'; //Black
	if (speed <= speedLimit) return '#2AAC30'; //Green
	if (speed > speedLimit && speed <= (speedLimit + 10)) return '#FF7337' //Orange
	else return '#ED2020' //Red
}

export const removeAccents = (text) => {
    // Map accented characters (including Vietnamese) to their base form
    const accentMap = {
        // Basic Latin vowels
        'á': 'a', 'à': 'a', 'ä': 'a', 'â': 'a', 'ã': 'a', 'å': 'a',
        'é': 'e', 'è': 'e', 'ë': 'e', 'ê': 'e',
        'í': 'i', 'ì': 'i', 'ï': 'i', 'î': 'i',
        'ó': 'o', 'ò': 'o', 'ö': 'o', 'ô': 'o', 'õ': 'o',
        'ú': 'u', 'ù': 'u', 'ü': 'u', 'û': 'u',
        'Á': 'A', 'À': 'A', 'Ä': 'A', 'Â': 'A', 'Ã': 'A',
        'É': 'E', 'È': 'E', 'Ë': 'E', 'Ê': 'E',
        'Í': 'I', 'Ì': 'I', 'Ï': 'I', 'Î': 'I',
        'Ó': 'O', 'Ò': 'O', 'Ö': 'O', 'Ô': 'O', 'Õ': 'O',
        'Ú': 'U', 'Ù': 'U', 'Ü': 'U', 'Û': 'U',

        // Vietnamese vowels and Đ/đ (covers examples like "Công viên phần mềm Đường Số 3 Đường Quang Trung")
        'ă': 'a', 'ắ': 'a', 'ằ': 'a', 'ẳ': 'a', 'ẵ': 'a', 'ặ': 'a',
        'â': 'a', 'ấ': 'a', 'ầ': 'a', 'ẩ': 'a', 'ẫ': 'a', 'ậ': 'a',
        'đ': 'd',
        'ê': 'e', 'ế': 'e', 'ề': 'e', 'ể': 'e', 'ễ': 'e', 'ệ': 'e',
        'ô': 'o', 'ố': 'o', 'ồ': 'o', 'ổ': 'o', 'ỗ': 'o', 'ộ': 'o',
        'ơ': 'o', 'ớ': 'o', 'ờ': 'o', 'ở': 'o', 'ỡ': 'o', 'ợ': 'o',
        'ư': 'u', 'ứ': 'u', 'ừ': 'u', 'ử': 'u', 'ữ': 'u', 'ự': 'u',
        'Ă': 'A', 'Ắ': 'A', 'Ằ': 'A', 'Ẳ': 'A', 'Ẵ': 'A', 'Ặ': 'A',
        'Â': 'A', 'Ấ': 'A', 'Ầ': 'A', 'Ẩ': 'A', 'Ẫ': 'A', 'Ậ': 'A',
        'Đ': 'D',
        'Ê': 'E', 'Ế': 'E', 'Ề': 'E', 'Ể': 'E', 'Ễ': 'E', 'Ệ': 'E',
        'Ô': 'O', 'Ố': 'O', 'Ồ': 'O', 'Ổ': 'O', 'Ỗ': 'O', 'Ộ': 'O',
        'Ơ': 'O', 'Ớ': 'O', 'Ờ': 'O', 'Ở': 'O', 'Ỡ': 'O', 'Ợ': 'O',
        'Ư': 'U', 'Ứ': 'U', 'Ừ': 'U', 'Ử': 'U', 'Ữ': 'U', 'Ự': 'U'
    };

    // Replace any accented character found in the map
    return text.replace(/./g, function (char) {
        return accentMap[char] || char;
    });
}


/********************************************************
 * Validate JSON
 ********************************************************/
export const isValidJson = (json) => {
	try {
		JSON.parse(json);
		return true;
	} catch (e) {
		return false;
	}
}

export function checkDeviceData(paramDeviceData) {
	let deviceData = paramDeviceData;
	if (deviceData && isValidJson(deviceData)) {
		deviceData = JSON.parse(paramDeviceData);
		//double parse because trail
		if (typeof deviceData == "string" && isValidJson(deviceData)) {
			deviceData = deviceData && JSON.parse(deviceData);
		}
	}
	return deviceData;
}

export const formatAddress = (element) => {
	let newAddress = element?.formattedAddress || '';
	if (!newAddress || newAddress == 'null') {
		if (element?.address && isValidJson(element?.address)) {
			const { formatted } = JSON.parse(element?.address)
			if (formatted) {
				newAddress = formatted || '';
			}
		} else {
			if (element?.address && element?.address?.formatted) {
				const { formatted } = element?.address
				newAddress = formatted
				return newAddress
			}
			newAddress = '';
		}
	}
	return newAddress
}

export const setLegacyUrl = (url, reseller) => {
	return (!window.location.hostname.includes('gpstrackit.com') && reseller?.legacyUrl) || url;
}

export const getLegacyUrl = (url) => {
	const legacyUrl = localStorage.getItem("legacyUrl");
	if (legacyUrl && legacyUrl != "undefined" && legacyUrl != "null") {
		return legacyUrl;
	}
	return url;
}
export const MILES_TO_KPH = 1.609344;

export const convertToKPH = (speedValue) => {
	let kph = 0;
	if (parseInt(speedValue) > 0) {
		kph = (speedValue * MILES_TO_KPH);
	}
	return Math.ceil(kph);
}
export const convertToKPHWithDecimals = (value, decimalPlaces = 2) => {
    const num = Number(value);
    if (isNaN(num) || num <= 0) {
        return 0;
    }
    const kph = num * MILES_TO_KPH;
    return Number(kph.toFixed(decimalPlaces));
}

export const KPH_TO_MI = 1 / MILES_TO_KPH;

export const convertToMI = (value) => {
	const num = Number(value);
	if (isNaN(num)) {
		return 0;
	}
	return (num * KPH_TO_MI);
}

export const convertToMIRound = (value) => {
	let mi = 0;
	if (parseInt(value) > 0) {
		mi = (value / MILES_TO_KPH);
	}
	return Math.round(mi);
}

export const parseUrl = (url) => {
	// delete the http or https to show an URL
	if (typeof url === 'string') {
		let newUrl = url.replace("https://", '');
		newUrl = newUrl.replace("http://", '')
		return newUrl;
	}
	return url;
}

export const isFacebookError = (error) => {
	// Error when the person does not allow the email in the Facebook authentication
	if (
		error &&
		error === "attributes required: [email]"
	) {
		return true
	}
	return false;
}

export const isAppleError = (error) => {
	// Error when the person does not allow the email in the Apple authentication
	if (
		error &&
		typeof error === "string" &&
		error.includes("privaterelay.appleid.com")
	) {
		return true
	}
	return false;
}

export const EmailNotFound = (error) => {
	if (typeof error === 'string' && error.includes('Sign in with Google')) {
		return true
	}
	return false;
}

export const ErrorHandlerLogin = (error, isPasswordError) => {
	let newError = error;

	if (newError) {
		// parse to string if the error is an object
		if (typeof newError == "object") {
			newError = newError.toString();
		}
		const errorMessageGraphql = /Error: Graphql error: /gi;
		newError = newError.replace(errorMessageGraphql, '');
		const errorCustomException = /CustomException:/gi;
		newError = newError.replace(errorCustomException, '');
		// Message displayed when user attempts to log in or reset password more than 5 times in a row
		const errorMessageLimit = /LimitExceededException: /gi;
		newError = newError.replace(errorMessageLimit, '');
		const errorMessagePrefix = /Error: /gi;
		newError = newError.replace(errorMessageGraphql, '');
		newError = newError.replace(errorMessagePrefix, '');
		const errorMessageApollo = /Apollo/gi;
		newError = newError.replace(errorMessageApollo, '');
		// implement language to message from cognito
		if (isPasswordError && newError.includes('Incorrect username or password.')) {
			return 'login_password_incorrect';
		}
		return newError.trim();
	}
	return error;
}

export const forTesting = (isDeveloper) => {
	if (!isDeveloper && process.env.ENVIROMENT && (process.env.ENVIROMENT === "staging")) {
		isDeveloper = true;
	}

	if (!isDeveloper && process.env.ENVIROMENT === "beta") {
		isDeveloper = true;
	}
	return isDeveloper;
}
export const OrderData = (list, key) => {

	let newSortList = [...list].sort((a, b) => {
		const itemA = String(a[key]).toUpperCase();
		const itemB = String(b[key]).toUpperCase();

		if (itemA < itemB) {
			return -1;
		}

		if (itemA > itemB) {
			return 1;
		}

		return 0;
	});

	return newSortList;
};

export const GetFormatForDate = (dateFormat) => {
	let format = 'MM/dd/yyyy';

	if (dateFormat === 'm/d/Y') {
		format = 'MM/dd/yyyy';
	} else if (dateFormat === 'd/m/Y') {
		format = 'dd/MM/yyyy';
	} else if (dateFormat === 'Y/m/d') {
		format = 'yyyy/MM/dd';
	}

	return format;
};

export const GetFormatForMoment = (dateFormat) => {
	let format = 'MM/DD/YYYY';

	if (dateFormat === 'm/d/Y') {
		format = 'MM/DD/YYYY';
	} else if (dateFormat === 'd/m/Y') {
		format = 'DD/MM/YYYY';
	} else if (dateFormat === 'Y/m/d') {
		format = 'YYYY/MM/DD';
	}

	return format;
};

export const GetFormatForMomentTwoCharacters = (dateFormat) => {
	let format = 'MM/DD/YY';

	if (dateFormat === 'm/d/Y') {
		format = 'MM/DD/YY';
	} else if (dateFormat === 'd/m/Y') {
		format = 'DD/MM/YY';
	} else if (dateFormat === 'Y/m/d') {
		format = 'YY/MM/DD';
	}

	return format;
};

export const GetNumberDaysBetweenTwoDates = (date1, date2) => {
	var differenceInTime = date2.getTime() - date1.getTime();
	return differenceInTime / (1000 * 3600 * 24);
};

export const validateEmail = (email) => {
	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
};

export const MerginObjectArray = (originalArray, newArray, key = null) => {

	//***  merging array regarding its data */

	let merginObjectArray = originalArray
	newArray.map(element => {
		merginObjectArray = InsertIntoArray(merginObjectArray, element, key)
	})
	return merginObjectArray
}

export const InsertIntoArray = (arrayToInsert, data, key = null) => {

	//***  insert data in array checking if already exist */

	const index = key ? arrayToInsert.findIndex(element => element[key] === data[key]) :
		arrayToInsert.findIndex(element => element === data)

	if (index != -1) {
		arrayToInsert[index] = { ...arrayToInsert[index], ...data }
	}
	else {
		arrayToInsert.push(data)
	}

	return arrayToInsert
}

export const DayFormat = (value) => {
	let day
	switch (value) {
		case "monday":
			day = "MON"
			break;
		case "tuesday":
			day = "TUE"
			break;
		case "wednesday":
			day = "WED"
			break;
		case "thursday":
			day = "THU"
			break;
		case "friday":
			day = "FRI"
			break;
		case "saturday":
			day = "SAT"
			break;
		case "sunday":
			day = "SUN"
			break;
		default:
			break;
	}
	return day
}

export const formatCatalogAddress = (address) => {
	if (address && (address.address && address.zip && address.state || address.formatted)) {
		//return `${address.address}, ${address.formatted}, ${address.zip}, ${address.state}`;
		return `${address.formatted}` || `${address.address}, ${address.zip}, ${address.state}`;
	}
	return '';
};

export const formatCatalogDate = (unitTime, paramFormat = null) => {

	if (!unitTime) {
		return
	}

	const timeMoment = moment(unitTime);
	if (timeMoment.isValid()) {
		if (!paramFormat) {
			return `${timeMoment.format(GetFormatForMoment('m/d/Y') + ', h:mm a')} ${'(' + formatRelativeTimeText(timeMoment) + ')'}`
		} else {
			return `${timeMoment.format(paramFormat)} ${'(' + formatRelativeTimeText(timeMoment) + ')'}`
		}

	} else {
		//***  formatting integer timestamps to readable dates */

		let unixMoment


		if (unitTime && unitTime.length > 10) {
			unixMoment = moment.unix(Number(unitTime?.substring(0, unitTime.length - 3)))
		} else {
			unixMoment = moment.unix(Number(unitTime))
		}


		if (unixMoment.isValid()) {
			if (!paramFormat) {
				return `${unixMoment.format(GetFormatForMoment('m/d/Y') + ', h:mm a')} ${'(' + formatRelativeTimeText(unixMoment) + ')'}`
			} else {
				return `${unixMoment.format(paramFormat)} ${'(' + formatRelativeTimeText(unixMoment) + ')'}`
			}
		}

		//***  formatting integer timestamps to readable dates */
	}

	return

};

export const formatOffsetDisplayOdometer = (unit) => {
	const baseRaw = unit?.useEcuOdometer ? unit?.ecuEngineOdometer : unit?.engineOdometer;
	if (baseRaw === null || baseRaw === undefined || baseRaw === '') return '';
	const baseNum = Number(baseRaw);
	if (!Number.isFinite(baseNum)) return '';

	const offRaw = unit?.useEcuOdometer ? unit?.offsetEcuEngineOdometer : unit?.offsetEngineOdometer;
	const offsetNumeric = offRaw === null || offRaw === undefined || offRaw === '' ? 0 : Number(offRaw);
	const offsetAdditive = Number.isFinite(offsetNumeric) ? offsetNumeric : 0;

	const result = Math.round(baseNum + offsetAdditive);

	if (result !== null && result !== undefined)
		if (result < 0)
			return 0
		else
			return result

	return ''
}

export const formatOffsetDisplayEngineHours = (unit) => {

  const base = unit?.useEcuEngineHours ? unit?.ecuEngineHours : unit?.engineHours;
  const offset = unit?.useEcuEngineHours ? unit?.offsetEcuEngineHours : unit?.offsetEngineHours;

   if (base === null || base === undefined || base === '') return '';

	const baseNum = Number(base);
	if (!Number.isFinite(baseNum)) return '';

	const offsetNumeric = offset === null || offset === undefined || offset === '' ? 0 : Number(offset);
	const offsetAdditive = Number.isFinite(offsetNumeric) ? offsetNumeric : 0;
	const result = baseNum + offsetAdditive;

  if (!Number.isFinite(result)) return '0.00';

  return result < 0 ? '0.00' : result.toFixed(2);
};

export const roundTo = (n, place = 2) => {
	return +(Math.round(n + "e+" + place) + "e-" + place);
}

export const getValueFloat = (value) => {
	return parseFloat(value || 0);
}

export const isJson = (str) => {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}

export const round = (value, precision) => {
	var multiplier = Math.pow(10, precision || 0);
	return Math.round(value * multiplier) / multiplier;
}

const UNSAFE_OBJECT_KEYS = new Set(['__proto__', 'constructor', 'prototype']);

// Copies the own enumerable properties of source onto target, like Object.assign, but skips the keys that
// reach the prototype chain: an own "__proto__" key in a parsed JSON payload (socket events, API data) would
// otherwise invoke the setter and swap the prototype of target.
export const assignOwnProps = (target, source) => {
	if (!source || typeof source !== 'object') return target;
	for (const key of Object.keys(source)) {
		if (UNSAFE_OBJECT_KEYS.has(key)) continue;
		target[key] = source[key];
	}
	return target;
};

export const createUUID = () => {
	const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	return pattern.replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
};


export const convertIntFromObjectToBoolean = (data) => {
	if (!data) {
		return null;
	}

	let newData = { ...data }
	Object.keys(data)?.forEach((key) => {
		let value = data[key];
		if (typeof value === "boolean") {
			newData = { ...newData, [key]: value ? 1 : 0 };
		}
	});

	return newData;
};

export const convertStringToIntegerBoolean = (value = '') => {
	let newValue = value.toString().toLowerCase() == 'on' ? 1 : 0;
	if (newValue == 0 && value != '' && !isNaN(value)) {
		return parseInt(value);
	} else if (newValue == 1) {
		return newValue;
	}

	return value;
};

export const getCordinatesAndRadius = (landmark) => {
	// Method to get radius and cordinates given a landmark
	let radius = 0;
	let coordinatesCenter = [];
	if (landmark) {
		radius = landmark.shape == "circle" ? landmark.radius : 0;
		coordinatesCenter = radius > 0 ? [{ lat: landmark.latitude, lng: landmark.longitude }] : landmark.coordinates;
	}

	return {
		radius,
		coordinatesCenter
	}
}

//Convertions epoch time
export const convertEpochTimeToMoment = (unitTimeParam) => {
	if (!Number.isInteger(Number(unitTimeParam))) {
		return unitTimeParam
	}

	if (unitTimeParam.toString().length == 10) {
		return moment.unix(Number(unitTimeParam)); //seconds
	}
	return moment(Number(unitTimeParam)); //milliseconds
}

export const cutNotes = (note, maxLength = 10) => {
	let notes = note ? note : ''
	if (notes.length > maxLength) {
		notes = `${notes.slice(0, maxLength)}...`;
	}
	return notes
}

export const clearStringValue = (stringValue) => {
	//remove true
	stringValue = (stringValue + '').toString() != 'true' ? stringValue : ''

	return stringValue
}

export const clearNumberValue = (numberValue) => {

	if (!isNaN(parseFloat(numberValue)) && isFinite(numberValue))
		//remove true
		numberValue = parseFloat(numberValue)
	else
		numberValue = null

	return numberValue
}

export const validateJsonObject = (object) => {
	if (object) {
		if (typeof object === 'string') {
			try {
				return JSON.parse(object);
			} catch (e) {
				return object;
			}
		} else if (typeof object === 'object') {
			return object;
		}
	}
}

export const convertJsonObject = (object) => {
	if (object) {
		if (typeof object === 'string') {
			try {
				return JSON.parse(object);
			} catch (e) {
				return null;
			}
		} else if (typeof object === 'object') {
			return object;
		}
	}
	return null
}

export const createMomentTimeZone = (date, timeZone, convertToUTC) => {
	//  converts a given date to a given timezone
	if (momentTz(date).isValid()) {
		return momentTz(date, timeZone).format();
	}
	return date;
}

export const dateTimeZoneToUTC = (date, timezone) => {
	if (momentTz(date).isValid()) {
		const newDate = momentTz(date).format('YYYY-MM-DD HH:mm:ss');
		var a = momentTz.tz(newDate, timezone);
		const utcTime = a.utc().format();
		return utcTime;
	}
	return date;
}

/**
 * Convert a UTC date string to a Date object that displays the time in the specified timezone.
 * 
 * @param {string} utcDateString - UTC date string
 * @param {string} targetTimezone - Target timezone
 * @returns {Date} Date object that displays the target timezone's time values
 */
export const convertUTCToDateInTimezone = (utcDateString, targetTimezone) => {
	// Parse UTC string and convert to target timezone
	const dateInTargetTz = momentTz.utc(utcDateString).tz(targetTimezone).toDate();
	
	return dateInTargetTz;
};

export const getDateTimeZoneUser = (date, timeZone) => {
	let momentDate = moment(date).tz(timeZone);
	if (momentDate.isValid()) {
		if (Number.isInteger(date)) {
			if (date.toString().length > 10) date = (date / 1000);
			momentDate = momentTz.unix(date);
			momentDate = momentDate.tz(timeZone).format();
			return momentDate;
		}
		return momentDate = momentTz(date).tz(timeZone).format();
	}
	return date;
}

export const getUserFormattedDate = (user, date, messages, timeFormat, onlyDate = false, dateFirst = false) => {
	let momentDate = "";
	if (!date || !messages) return;

	if (!user) {
		if (moment().isSame(moment(date), 'day')) {
			return `${messages["date_today"]} ${messages['at']} ${moment(date).format("hh:mm A z")}`;
		} else if (moment().subtract(1, 'd').format("DD") === moment(date).format("DD")) {
			return `${messages["date_yesterday"]} ${messages['at']} ${moment(date).format("hh:mm A z")}`;
		}

		return moment(date).format("MM/DD/YYYY hh:mm A z");
	}

	const momentFormat = GetFormatForMoment(user.dateformat);

	if (Number.isInteger(date * 1)) {
		if (date.toString().length > 10) date = (date / 1000);

		momentDate = momentTz.unix(date);
		momentDate = momentDate.tz(user.timeZone);
	} else if (typeof date === 'string') {
		momentDate = momentTz(date).tz(user.timeZone);
	}

	if (!momentDate) return;

	if (!timeFormat) {
		if (momentTz().tz(user.timeZone).isSame(momentDate, 'day')) {
			return `${messages["date_today"]} ${messages['at']} ${momentDate.format(`${!onlyDate ? 'h:mm A' : ''}`)}`;
		} else if (momentTz().tz(user.timeZone).subtract(1, 'd').format("DD") === momentDate.format("DD") && momentTz().tz(user.timeZone).subtract(1, 'd').format("MM") === momentDate.format("MM")) {
			return `${messages["date_yesterday"]} ${messages['at']} ${momentDate.format(`${!onlyDate ? 'h:mm A' : ''}`)}`;
		}
	}

	if (onlyDate) {
		return momentDate.utc().format(momentFormat)
	} else if (dateFirst) {
		return momentDate.format(`${momentFormat}, ${timeFormat || 'h:mm A'}`);
	} else {
		return momentDate.format(`${timeFormat || 'h:mm A'}, ${momentFormat}`);
	}
}

export const converSpeedToMph = (speed, unitType) => {
	let mph = 0
	switch (unitType) {
		case 'Calamp': //Calamp 1100
			mph = (speed * 0.0223693629); //cps to mph
			break;
		case 'Webtech':
			mph = (speed * 0.621371192); //kph to mph
			break;
		default:
			mph = speed;
			break;
	}
	return mph
}

export const conversionTimeZone = (timezone) => {
	let response = timezone
	switch (timezone) {
		case 'UCT':
			response = 'Etc/UCT'
			break
		case 'Universal':
			response = 'Etc/UTC'
			break
		case 'US/Alaska':
			response = 'America/Anchorage'
			break
		case 'US/Aleutian':
			response = 'America/Adak'
			break
		case 'US/Arizona':
			response = 'America/Phoenix'
			break
		case 'US/Central':
			response = 'America/Chicago'
			break
		case 'US/Eastern':
			response = 'America/New_York'
			break
		case 'US/East-Indiana':
			response = 'America/Indiana/Indianapolis'
			break
		case 'US/Hawaii':
			response = 'Pacific/Honolulu'
			break
		case 'US/Indiana-Starke':
			response = 'America/Indiana/Knox'
			break
		case 'US/Michigan':
			response = 'America/Detroit'
			break
		case 'US/Mountain':
			response = 'America/Denver'
			break
		case 'US/Pacific':
			response = 'America/Los_Angeles'
			break
		case 'US/Pacific-New':
			response = 'America/Los_Angeles'
			break
		case 'US/Samoa':
			response = 'Pacific/Pago_Pago'
			break
	}
	return response
}

export const headingToDirection = (num) => {
	if (num && !isNaN(num)) {
		const directions = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
		return directions[Math.round(num / 45) % 8];
	}
	return '';
}

export const getFormattedDateByTimeZone = (date, timeZone, messages, format, fromNow, locale = 'en') => {
	let momentDate = "";
	moment.locale(locale);
	if (!date || !timeZone || !messages) return;

	if (Number.isInteger(date * 1)) {
		if (date.toString().length > 10) date = (date / 1000);

		momentDate = momentTz.unix(date);
		momentDate = momentDate.tz(timeZone);
	} else if (typeof date === 'string') {
		momentDate = momentTz(date).tz(timeZone);
	}

	if (!momentDate) return;

	if (format) return `${momentDate.format(format)} ${fromNow ? `(${formatRelativeTimeText(momentDate, locale)})` : ''}`;

	if (momentTz().tz(timeZone).isSame(momentDate, 'day')) {
		return `${messages["date_today"]} ${messages['at']} ${momentDate.format('h:mm A')}`;
	} else if (momentTz().tz(timeZone).subtract(1, 'd').format("DD") === momentDate.format("DD")) {
		return `${messages["date_yesterday"]} ${messages['at']} ${momentDate.format('h:mm A')}`;
	}

	return `${momentDate.format('Y/m/d h:mm A')} ${fromNow ? `(${formatRelativeTimeText(momentDate, locale)})` : ''}`;
}

//csv is the CSV file with headers
export const csvJSON = (csv) => {
	try {
		let lines = csv.split("\n");
		let result = [];
		let headers = lines[0].split(",");
		headers = headers.filter((item) => item != '' && item != ' ' && item != '\r');
		headers = headers.map((item) => item.replace('\r', ''));

		for (let i = 1; i < lines.length; i++) {
			let obj = {};
			let currentline = lines[i].split(",");
			const validateCurrentline = currentline.filter((item) => item != '' && item != ' ' && item != '\r');

			if (validateCurrentline && validateCurrentline.length > 0) {
				for (let j = 0; j < headers.length; j++) {
					let dataToInsert = currentline[j]
					dataToInsert = dataToInsert ? dataToInsert.replace('\r', '') : '';
					obj[headers[j]] = dataToInsert;
				}
				result.push(obj);
			}
		}
		return result;

	} catch (ex) {
		return ex;
	}
}

export const downloadFile = (content, fileName, mimeType) => {
	var a = document.createElement('a');
	mimeType = mimeType || 'application/octet-stream';

	if (navigator.msSaveBlob) { // IE10
		navigator.msSaveBlob(new Blob([content], {
			type: mimeType
		}), fileName);
	} else if (URL && 'download' in a) { //html5 A[download]
		a.href = URL.createObjectURL(new Blob([content], {
			type: mimeType
		}));
		a.setAttribute('download', fileName);
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	} else {
		location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
	}
}

//Convert the hex color to RGB
export const convertHexToRgb = (hexColor) => {

	if (hexColor) {
		hexColor = hexColor.replace('#', '');
	}

	if (hexColor?.length === 3) {
		hexColor = hexColor.split('').map(char => char + char).join('');
	}

	//Only six-digit hex colors are allowed.
	if (hexColor && hexColor.length != 6 || !hexColor) {
		return [];
	}

	let r1 = parseInt(hexColor.substring(0, 2), 16);
	let g1 = parseInt(hexColor.substring(2, 4), 16);
	let b1 = parseInt(hexColor.substring(4, 6), 16);
	return [parseInt(r1), parseInt(g1), parseInt(b1)];
}

export const convertWhiteColor = (color) => {

	if (!color || color == "#") return '#D0D3D4';

	//evaluate white color
	let rgbColor = convertHexToRgb(color);
	if (rgbColor && rgbColor.length > 0) {
		//evaluate color white
		if (rgbColor[0] > 210 && rgbColor[1] > 210 && rgbColor[2] > 210) {
			return '#D0D3D4'
		}
	} else {
		//when the color name is white
		if (color && color.toLowerCase() == 'white') {
			return '#D0D3D4'
		}
	}
	return color.includes('#') ? color : `#${color}`;
}

export const copyArrayOrObject = (array) => {
	if (array && typeof array === 'object') {
		return JSON.parse(JSON.stringify(array))
	}
	return array
}

export const detectBrowser = () => {
	// Return the current browser name
	if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
		return 'Opera';
	} else if (navigator.userAgent.indexOf("Chrome") != -1) {
		return 'Chrome';
	} else if (navigator.userAgent.indexOf("Safari") != -1) {
		return 'Safari';
	} else if (navigator.userAgent.indexOf("Firefox") != -1) {
		return 'Firefox';
	} else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) {
		return 'IE';//crap
	} else {
		return 'Unknown';
	}
}

export const copyToClipboard = (text) => {
	if (text === null || text === undefined) return;

	const valueToCopy = `${text}`;
	if (valueToCopy.length === 0) return;

	navigator.clipboard.writeText(valueToCopy).then(() => {
		const successMessage = localStorage.getItem('lan') === 'es' ? 'Copiado' : 'Copied!';
		NotificationManager.success(successMessage);
	});
}

export const getTagColor = (color) => {
	if (!color) return "000000";

	let notAvailableColors = [
		'white',
		'fff',
		'ffffff'
	];

	let newColor = color?.toLowerCase();
	if (notAvailableColors?.includes(newColor)) {
		return "000000";
	}

	return color;
}

export const errorCodeHandler = (errorCode) => {
	const errors = {
		'1010': 'duplicated_name',
		'1011': 'invalid_params',
		'1002ftp': 'exist_ftp',
		'1010ftp': 'duplicated_name',
		'1011ftp': 'invalid_params_ftp'
	}
	return errors[errorCode] || '';
}

export const getApiErrorMessage = (payload) => {
	const err =
		payload?.errorData?.errors?.[0] ||
		payload?.innerError?.errors?.[0];

	if (err?.errorType === "CustomException" && err?.message) {
		return err.message;
	}

	return null;
};

export const mapApiError = (payload, messageMap = {}, fallback = true) => {
	const message = getApiErrorMessage(payload);
	if (!message) return fallback;
	return Object.prototype.hasOwnProperty.call(messageMap, message)
		? messageMap[message]
		: message;
};

export const download = (url, name, callback) => {
	if (url) {
		axios({
			url: url,
			method: 'GET',
			responseType: 'blob',
		}).then((response) => {
			const urlObject = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = urlObject;
			link.setAttribute('download', name);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			if (callback) callback();
		});
	}
};

export const formatTimeDelta = (timedelta) => {
	let minutes = Math.floor(timedelta / 60);
	const seconds = timedelta % 60;
	if (minutes > 60) {
		let hours = Math.floor(minutes / 60);
		minutes = minutes % 60;
		if (hours > 24) {
			const days = Math.floor(hours / 24);
			hours = hours % 24;
			return `${days || 0} days, ${hours || 0} hr, ${minutes || 0} min`;
		}
		return `${hours || 0} hr, ${minutes || 0} min`;
	}

	return `${minutes || 0} min`;
}

export const formatTimeHour = (timedelta, messages) => {
	if (!timedelta) return `0 ${messages["reportsMainRT_hours"]}`

	let hours = Number.parseFloat(timedelta / 3600).toFixed(2);
	return `${hours} ${messages["reportsMainRT_hours"]} `;
}

export const getPreferencesByKey = (preferencesUser, key) => {
	let preferences = {};
	if (preferencesUser && key) {
		let preferencesKeyTemp = preferencesUser.find(x => x.preferenceKey === key);
		let preferencesJSON = preferencesKeyTemp && preferencesKeyTemp.preferenceValue != "" && preferencesKeyTemp.preferenceValue || "{}";
		preferences = JSON.parse(preferencesJSON);
	}

	return preferences;
}

export const getFormattedField = (field, unit) => {
	if (field) {
		return `${field} ${unit}`;
	}

	return 'N/A';
};

export const getUnitsNaturalOrder = (units) => {
	try {
		return units.sort(function (a, b) {
			return a.label?.localeCompare(b.label, undefined, {
				numeric: true,
				sensitivity: 'base'
			})
		})
	} catch (error) {
		return units
	}
}

export const getVidFleetConfigValues = () => {
	return {
		dms: {
			minSpeed: {
				USING_PHONE: { default: 40, max: 200, min: 0 },
				DROWSINESS: { default: 40, max: 200, min: 0 },
				DAYDREAMING: { default: 40, max: 200, min: 0 },
				DISTRACTED: { default: 40, max: 200, min: 40 },
				ATTENTIVE: { default: 0, max: 200, min: 0 },
				NO_SEATBELT: { default: 40, max: 200, min: 8 },
				YAWN: { default: 40, max: 200, min: 40 },
				SMOKING: { default: 40, max: 200, min: 0 },
				ASLEEP: { default: 40, max: 200, min: 0 },
				NO_DRIVER: { default: 8, max: 200, min: 8 },
				IDLE_NO_DRIVER: { default: 0, max: 200, min: 0 }
			},
			detectionDelay: {
				USING_PHONE: { default: 50, max: 4000, min: 20 },
				DROWSINESS: { default: 5, max: 4000, min: 5 },
				DAYDREAMING: { default: 10, max: 4000, min: 5 },
				DISTRACTED: { default: 40, max: 4000, min: 20 },
				ATTENTIVE: { default: 0, max: 4000, min: 5 },
				NO_SEATBELT: { default: 200, max: 4000, min: 50 },
				YAWN: { default: 5, max: 4000, min: 5 },
				SMOKING: { default: 10, max: 4000, min: 5 },
				ASLEEP: { default: 4, max: 4000, min: 5 },
				NO_DRIVER: { default: 600, max: 4000, min: 300 },
				IDLE_NO_DRIVER: { default: 1800, max: 4000, min: 1200 }
			},
			repeatInterval: {
				USING_PHONE: { default: 6000, max: 12000, min: 6000 },
				DROWSINESS: { default: 1200, max: 12000, min: 1200 },
				DAYDREAMING: { default: 6000, max: 12000, min: 6000 },
				DISTRACTED: { default: 3000, max: 12000, min: 3000 },
				ATTENTIVE: { default: 6000, max: 12000, min: 6000 },
				NO_SEATBELT: { default: 6000, max: 12000, min: 6000 },
				YAWN: { default: 300, max: 12000, min: 3000 },
				SMOKING: { default: 6000, max: 12000, min: 6000 },
				ASLEEP: { default: 1200, max: 12000, min: 1200 },
				NO_DRIVER: { default: 6000, max: 12000, min: 6000 },
				IDLE_NO_DRIVER: { default: 6000, max: 12000, min: 6000 }
			},
			detectionReset: {
				USING_PHONE: { default: 10, max: 200, min: 10 },
				DROWSINESS: { default: 0, max: 200, min: 0 },
				DAYDREAMING: { default: 0, max: 200, min: 0 },
				DISTRACTED: { default: 10, max: 200, min: 10 },
				ATTENTIVE: { default: 0, max: 200, min: 0 },
				NO_SEATBELT: { default: 5, max: 200, min: 5 },
				YAWN: { default: 20, max: 200, min: 20 },
				SMOKING: { default: 0, max: 200, min: 0 },
				ASLEEP: { default: 0, max: 200, min: 0 },
				NO_DRIVER: { default: 0, max: 200, min: 0 },
				IDLE_NO_DRIVER: { default: 10, max: 200, min: 10 }
			}
		},
		advanced: {
			adas: {
				minSpeed: {
					FORWARD_COLLISION_WARNING: { default: 0, max: 200, min: 0 },
					HEADWAY_MONITORING_WARNING: { default: 65, max: 200, min: 65 },
					HEADWAY_MONITORING_EMERGENCY: { default: 65, max: 200, min: 65 },
					LANE_DEPARTURE_WARNING: { default: 50, max: 200, min: 50 },
					STOP_SIGN_VIOLATION: { default: 10, max: 200, min: 8 }
				},
				detectionDelay: {
					FORWARD_COLLISION_WARNING: { default: 5, max: 200, min: 5 },
					HEADWAY_MONITORING_WARNING: { default: 5, max: 200, min: 5 },
					HEADWAY_MONITORING_EMERGENCY: { default: 30, max: 200, min: 30 },
					LANE_DEPARTURE_WARNING: { default: 20, max: 200, min: 20 },
					STOP_SIGN_VIOLATION: { default: 10, max: 200, min: 10 }
				},
				repeatInterval: {
					FORWARD_COLLISION_WARNING: { default: 3000, max: 12000, min: 3000 },
					HEADWAY_MONITORING_WARNING: { default: 3000, max: 12000, min: 3000 },
					HEADWAY_MONITORING_EMERGENCY: { default: 3000, max: 12000, min: 3000 },
					LANE_DEPARTURE_WARNING: { default: 1200, max: 12000, min: 1200 },
					STOP_SIGN_VIOLATION: { default: 1200, max: 12000, min: 1200 }
				},
				detectionReset: {
					FORWARD_COLLISION_WARNING: { default: 5, max: 200, min: 5 },
					HEADWAY_MONITORING_WARNING: { default: 10, max: 200, min: 10 },
					HEADWAY_MONITORING_EMERGENCY: { default: 10, max: 200, min: 10 },
					LANE_DEPARTURE_WARNING: { default: 10, max: 200, min: 10 },
					STOP_SIGN_VIOLATION: { default: 10, max: 200, min: 10 }
				}
			},
			safetyAssistance: {
				alarm: {
					NO_SEATBELT: {
						enable: true,
						default: 7,
						max: 30,
						min: 5
					},
					DISTRACTED: {
						enable: true,
						default: 5,
						max: 30,
						min: 2
					},
					CLOSE_FOLLOWING: {
						enable: false,
						default: 1,
						max: 30,
						min: 1
					},
					LANE_DEPARTURE: {
						enable: true,
						default: 4,
						max: 30,
						min: 2
					},
					USING_CELLPHONE: {
						enable: true,
						default: 7,
						max: 30,
						min: 3
					},
					NO_DRIVER: {
						enable: true,
						default: 10,
						max: 30,
						min: 50
					},
					TAILGATING: {
						enable: true,
						default: 60,
						max: 200,
						min: 50
					},
					SPEEDING: {
						enable: false,
						default: 50,
						max: 200,
						min: 30
					},
					PASSENGERS_NO_SEATBELT: {
						enable: false,
						default: 50,
						max: 200,
						min: 30
					},
					OVER_MAX_SPEED: {
						enable: false,
						default: 50,
						max: 200,
						min: 30
					},
					PEDESTRIAN: {
						enable: false,
						default: 50,
						max: 200,
						min: 30
					},
					CYCLIST: {
						enable: false,
						default: 50,
						max: 200,
						min: 30
					},
					count: {
						min: 1,
						max: 10,
						default: 5
					}
				}
			},
			nav: {
				maxSpeed: {
					OVER_MAX_SPEED: { default: 120, max: 200, min: 8 }
				},
				minSpeed: {
					SPEEDING: { default: 40, max: 200, min: 40 },
					OVER_MAX_SPEED: { default: 40, max: 200, min: 40 }
				},
				detectionDelay: {
					SPEEDING: { default: 100, max: 200, min: 8 },
					OVER_MAX_SPEED: { default: 50, max: 200, min: 8 }
				},
				repeatInterval: {
					SPEEDING: { default: 600, max: 12000, min: 8 },
					OVER_MAX_SPEED: { default: 600, max: 12000, min: 8 }
				},
				detectionReset: {
					SPEEDING: { default: 10, max: 200, min: 8 },
					OVER_MAX_SPEED: { default: 10, max: 200, min: 8 }
				},
				overspeedLimit: {
					SPEEDING: { default: 10, max: 200, min: 10 },
					OVER_MAX_SPEED: { default: 0, max: 200, min: 0 }
				}
			}
		}
	}
}

export const validateProperty = (array, property) => {
	if (array.length === 0) {
		return true;
	}
	const firstValue = array[0][property];
	return array.every(obj => obj[property] === firstValue);
}


/**
 * Method to transform miles to KPH
 * @param {*} distance  number
 * @param {*} kph  number
 * @returns 
 */
export const milesToKPH = (miles, kph) => {
	if (miles < 0) {
		return '0.00'
	}
	const MILES_TO_KPH = 1.60934
	const formatMiles = miles ? Number(miles) : 0
	const newDistance = kph ? formatMiles * MILES_TO_KPH : formatMiles
	return newDistance ? newDistance?.toFixed(2) || 0 : '0.00';
}
export const formatUnixToDate = (unixtime, dateformat) => {
	if (!unixtime) {
		return "N/A";
	}

	const momentFormat = GetFormatForDate(dateformat);
	const momentDate = moment.unix(unixtime);
	return momentDate.format(`h:mm:ss A, ${momentFormat}`);
}

export const getCountryCodes = () => {
	return [
		{
			"name": "Afghanistan",
			"id": "93",
			"code": "AF"
		},
		{
			"name": "Aland Islands",
			"id": "358",
			"code": "AX"
		},
		{
			"name": "Albania",
			"id": "355",
			"code": "AL"
		},
		{
			"name": "Algeria",
			"id": "213",
			"code": "DZ"
		},
		{
			"name": "AmericanSamoa",
			"id": "1684",
			"code": "AS"
		},
		{
			"name": "Andorra",
			"id": "376",
			"code": "AD"
		},
		{
			"name": "Angola",
			"id": "244",
			"code": "AO"
		},
		{
			"name": "Anguilla",
			"id": "1264",
			"code": "AI"
		},
		{
			"name": "Antarctica",
			"id": "672",
			"code": "AQ"
		},
		{
			"name": "Antigua and Barbuda",
			"id": "1268",
			"code": "AG"
		},
		{
			"name": "Argentina",
			"id": "54",
			"code": "AR"
		},
		{
			"name": "Armenia",
			"id": "374",
			"code": "AM"
		},
		{
			"name": "Aruba",
			"id": "297",
			"code": "AW"
		},
		{
			"name": "Australia",
			"id": "61",
			"code": "AU"
		},
		{
			"name": "Austria",
			"id": "43",
			"code": "AT"
		},
		{
			"name": "Azerbaijan",
			"id": "994",
			"code": "AZ"
		},
		{
			"name": "Bahamas",
			"id": "1242",
			"code": "BS"
		},
		{
			"name": "Bahrain",
			"id": "973",
			"code": "BH"
		},
		{
			"name": "Bangladesh",
			"id": "880",
			"code": "BD"
		},
		{
			"name": "Barbados",
			"id": "1246",
			"code": "BB"
		},
		{
			"name": "Belarus",
			"id": "375",
			"code": "BY"
		},
		{
			"name": "Belgium",
			"id": "32",
			"code": "BE"
		},
		{
			"name": "Belize",
			"id": "501",
			"code": "BZ"
		},
		{
			"name": "Benin",
			"id": "229",
			"code": "BJ"
		},
		{
			"name": "Bermuda",
			"id": "1441",
			"code": "BM"
		},
		{
			"name": "Bhutan",
			"id": "975",
			"code": "BT"
		},
		{
			"name": "Bolivia, Plurinational State of",
			"id": "591",
			"code": "BO"
		},
		{
			"name": "Bosnia and Herzegovina",
			"id": "387",
			"code": "BA"
		},
		{
			"name": "Botswana",
			"id": "267",
			"code": "BW"
		},
		{
			"name": "Brazil",
			"id": "55",
			"code": "BR"
		},
		{
			"name": "British Indian Ocean Territory",
			"id": "246",
			"code": "IO"
		},
		{
			"name": "Brunei Darussalam",
			"id": "673",
			"code": "BN"
		},
		{
			"name": "Bulgaria",
			"id": "359",
			"code": "BG"
		},
		{
			"name": "Burkina Faso",
			"id": "226",
			"code": "BF"
		},
		{
			"name": "Burundi",
			"id": "257",
			"code": "BI"
		},
		{
			"name": "Cambodia",
			"id": "855",
			"code": "KH"
		},
		{
			"name": "Cameroon",
			"id": "237",
			"code": "CM"
		},
		{
			"name": "Canada",
			"id": "1",
			"code": "CA"
		},
		{
			"name": "Cape Verde",
			"id": "238",
			"code": "CV"
		},
		{
			"name": "Cayman Islands",
			"id": " 345",
			"code": "KY"
		},
		{
			"name": "Central African Republic",
			"id": "236",
			"code": "CF"
		},
		{
			"name": "Chad",
			"id": "235",
			"code": "TD"
		},
		{
			"name": "Chile",
			"id": "56",
			"code": "CL"
		},
		{
			"name": "China",
			"id": "86",
			"code": "CN"
		},
		{
			"name": "Christmas Island",
			"id": "61",
			"code": "CX"
		},
		{
			"name": "Cocos (Keeling) Islands",
			"id": "61",
			"code": "CC"
		},
		{
			"name": "Colombia",
			"id": "57",
			"code": "CO"
		},
		{
			"name": "Comoros",
			"id": "269",
			"code": "KM"
		},
		{
			"name": "Congo",
			"id": "242",
			"code": "CG"
		},
		{
			"name": "Congo, The Democratic Republic of the Congo",
			"id": "243",
			"code": "CD"
		},
		{
			"name": "Cook Islands",
			"id": "682",
			"code": "CK"
		},
		{
			"name": "Costa Rica",
			"id": "506",
			"code": "CR"
		},
		{
			"name": "Cote d'Ivoire",
			"id": "225",
			"code": "CI"
		},
		{
			"name": "Croatia",
			"id": "385",
			"code": "HR"
		},
		{
			"name": "Cuba",
			"id": "53",
			"code": "CU"
		},
		{
			"name": "Cyprus",
			"id": "357",
			"code": "CY"
		},
		{
			"name": "Czech Republic",
			"id": "420",
			"code": "CZ"
		},
		{
			"name": "Denmark",
			"id": "45",
			"code": "DK"
		},
		{
			"name": "Djibouti",
			"id": "253",
			"code": "DJ"
		},
		{
			"name": "Dominica",
			"id": "1767",
			"code": "DM"
		},
		{
			"name": "Dominican Republic",
			"id": "1849",
			"code": "DO"
		},
		{
			"name": "Ecuador",
			"id": "593",
			"code": "EC"
		},
		{
			"name": "Egypt",
			"id": "20",
			"code": "EG"
		},
		{
			"name": "El Salvador",
			"id": "503",
			"code": "SV"
		},
		{
			"name": "Equatorial Guinea",
			"id": "240",
			"code": "GQ"
		},
		{
			"name": "Eritrea",
			"id": "291",
			"code": "ER"
		},
		{
			"name": "Estonia",
			"id": "372",
			"code": "EE"
		},
		{
			"name": "Ethiopia",
			"id": "251",
			"code": "ET"
		},
		{
			"name": "Falkland Islands (Malvinas)",
			"id": "500",
			"code": "FK"
		},
		{
			"name": "Faroe Islands",
			"id": "298",
			"code": "FO"
		},
		{
			"name": "Fiji",
			"id": "679",
			"code": "FJ"
		},
		{
			"name": "Finland",
			"id": "358",
			"code": "FI"
		},
		{
			"name": "France",
			"id": "33",
			"code": "FR"
		},
		{
			"name": "French Guiana",
			"id": "594",
			"code": "GF"
		},
		{
			"name": "French Polynesia",
			"id": "689",
			"code": "PF"
		},
		{
			"name": "Gabon",
			"id": "241",
			"code": "GA"
		},
		{
			"name": "Gambia",
			"id": "220",
			"code": "GM"
		},
		{
			"name": "Georgia",
			"id": "995",
			"code": "GE"
		},
		{
			"name": "Germany",
			"id": "49",
			"code": "DE"
		},
		{
			"name": "Ghana",
			"id": "233",
			"code": "GH"
		},
		{
			"name": "Gibraltar",
			"id": "350",
			"code": "GI"
		},
		{
			"name": "Greece",
			"id": "30",
			"code": "GR"
		},
		{
			"name": "Greenland",
			"id": "299",
			"code": "GL"
		},
		{
			"name": "Grenada",
			"id": "1473",
			"code": "GD"
		},
		{
			"name": "Guadeloupe",
			"id": "590",
			"code": "GP"
		},
		{
			"name": "Guam",
			"id": "1671",
			"code": "GU"
		},
		{
			"name": "Guatemala",
			"id": "502",
			"code": "GT"
		},
		{
			"name": "Guernsey",
			"id": "44",
			"code": "GG"
		},
		{
			"name": "Guinea",
			"id": "224",
			"code": "GN"
		},
		{
			"name": "Guinea-Bissau",
			"id": "245",
			"code": "GW"
		},
		{
			"name": "Guyana",
			"id": "595",
			"code": "GY"
		},
		{
			"name": "Haiti",
			"id": "509",
			"code": "HT"
		},
		{
			"name": "Holy See (Vatican City State)",
			"id": "379",
			"code": "VA"
		},
		{
			"name": "Honduras",
			"id": "504",
			"code": "HN"
		},
		{
			"name": "Hong Kong",
			"id": "852",
			"code": "HK"
		},
		{
			"name": "Hungary",
			"id": "36",
			"code": "HU"
		},
		{
			"name": "Iceland",
			"id": "354",
			"code": "IS"
		},
		{
			"name": "India",
			"id": "91",
			"code": "IN"
		},
		{
			"name": "Indonesia",
			"id": "62",
			"code": "ID"
		},
		{
			"name": "Iran, Islamic Republic of Persian Gulf",
			"id": "98",
			"code": "IR"
		},
		{
			"name": "Iraq",
			"id": "964",
			"code": "IQ"
		},
		{
			"name": "Ireland",
			"id": "353",
			"code": "IE"
		},
		{
			"name": "Isle of Man",
			"id": "44",
			"code": "IM"
		},
		{
			"name": "Israel",
			"id": "972",
			"code": "IL"
		},
		{
			"name": "Italy",
			"id": "39",
			"code": "IT"
		},
		{
			"name": "Jamaica",
			"id": "1876",
			"code": "JM"
		},
		{
			"name": "Japan",
			"id": "81",
			"code": "JP"
		},
		{
			"name": "Jersey",
			"id": "44",
			"code": "JE"
		},
		{
			"name": "Jordan",
			"id": "962",
			"code": "JO"
		},
		{
			"name": "Kazakhstan",
			"id": "77",
			"code": "KZ"
		},
		{
			"name": "Kenya",
			"id": "254",
			"code": "KE"
		},
		{
			"name": "Kiribati",
			"id": "686",
			"code": "KI"
		},
		{
			"name": "Korea, Democratic People's Republic of Korea",
			"id": "850",
			"code": "KP"
		},
		{
			"name": "Korea, Republic of South Korea",
			"id": "82",
			"code": "KR"
		},
		{
			"name": "Kuwait",
			"id": "965",
			"code": "KW"
		},
		{
			"name": "Kyrgyzstan",
			"id": "996",
			"code": "KG"
		},
		{
			"name": "Laos",
			"id": "856",
			"code": "LA"
		},
		{
			"name": "Latvia",
			"id": "371",
			"code": "LV"
		},
		{
			"name": "Lebanon",
			"id": "961",
			"code": "LB"
		},
		{
			"name": "Lesotho",
			"id": "266",
			"code": "LS"
		},
		{
			"name": "Liberia",
			"id": "231",
			"code": "LR"
		},
		{
			"name": "Libyan Arab Jamahiriya",
			"id": "218",
			"code": "LY"
		},
		{
			"name": "Liechtenstein",
			"id": "423",
			"code": "LI"
		},
		{
			"name": "Lithuania",
			"id": "370",
			"code": "LT"
		},
		{
			"name": "Luxembourg",
			"id": "352",
			"code": "LU"
		},
		{
			"name": "Macao",
			"id": "853",
			"code": "MO"
		},
		{
			"name": "Macedonia",
			"id": "389",
			"code": "MK"
		},
		{
			"name": "Madagascar",
			"id": "261",
			"code": "MG"
		},
		{
			"name": "Malawi",
			"id": "265",
			"code": "MW"
		},
		{
			"name": "Malaysia",
			"id": "60",
			"code": "MY"
		},
		{
			"name": "Maldives",
			"id": "960",
			"code": "MV"
		},
		{
			"name": "Mali",
			"id": "223",
			"code": "ML"
		},
		{
			"name": "Malta",
			"id": "356",
			"code": "MT"
		},
		{
			"name": "Marshall Islands",
			"id": "692",
			"code": "MH"
		},
		{
			"name": "Martinique",
			"id": "596",
			"code": "MQ"
		},
		{
			"name": "Mauritania",
			"id": "222",
			"code": "MR"
		},
		{
			"name": "Mauritius",
			"id": "230",
			"code": "MU"
		},
		{
			"name": "Mayotte",
			"id": "262",
			"code": "YT"
		},
		{
			"name": "Mexico",
			"id": "52",
			"code": "MX"
		},
		{
			"name": "Micronesia, Federated States of Micronesia",
			"id": "691",
			"code": "FM"
		},
		{
			"name": "Moldova",
			"id": "373",
			"code": "MD"
		},
		{
			"name": "Monaco",
			"id": "377",
			"code": "MC"
		},
		{
			"name": "Mongolia",
			"id": "976",
			"code": "MN"
		},
		{
			"name": "Montenegro",
			"id": "382",
			"code": "ME"
		},
		{
			"name": "Montserrat",
			"id": "1664",
			"code": "MS"
		},
		{
			"name": "Morocco",
			"id": "212",
			"code": "MA"
		},
		{
			"name": "Mozambique",
			"id": "258",
			"code": "MZ"
		},
		{
			"name": "Myanmar",
			"id": "95",
			"code": "MM"
		},
		{
			"name": "Namibia",
			"id": "264",
			"code": "NA"
		},
		{
			"name": "Nauru",
			"id": "674",
			"code": "NR"
		},
		{
			"name": "Nepal",
			"id": "977",
			"code": "NP"
		},
		{
			"name": "Netherlands",
			"id": "31",
			"code": "NL"
		},
		{
			"name": "Netherlands Antilles",
			"id": "599",
			"code": "AN"
		},
		{
			"name": "New Caledonia",
			"id": "687",
			"code": "NC"
		},
		{
			"name": "New Zealand",
			"id": "64",
			"code": "NZ"
		},
		{
			"name": "Nicaragua",
			"id": "505",
			"code": "NI"
		},
		{
			"name": "Niger",
			"id": "227",
			"code": "NE"
		},
		{
			"name": "Nigeria",
			"id": "234",
			"code": "NG"
		},
		{
			"name": "Niue",
			"id": "683",
			"code": "NU"
		},
		{
			"name": "Norfolk Island",
			"id": "672",
			"code": "NF"
		},
		{
			"name": "Northern Mariana Islands",
			"id": "1670",
			"code": "MP"
		},
		{
			"name": "Norway",
			"id": "47",
			"code": "NO"
		},
		{
			"name": "Oman",
			"id": "968",
			"code": "OM"
		},
		{
			"name": "Pakistan",
			"id": "92",
			"code": "PK"
		},
		{
			"name": "Palau",
			"id": "680",
			"code": "PW"
		},
		{
			"name": "Palestinian Territory, Occupied",
			"id": "970",
			"code": "PS"
		},
		{
			"name": "Panama",
			"id": "507",
			"code": "PA"
		},
		{
			"name": "Papua New Guinea",
			"id": "675",
			"code": "PG"
		},
		{
			"name": "Paraguay",
			"id": "595",
			"code": "PY"
		},
		{
			"name": "Peru",
			"id": "51",
			"code": "PE"
		},
		{
			"name": "Philippines",
			"id": "63",
			"code": "PH"
		},
		{
			"name": "Pitcairn",
			"id": "872",
			"code": "PN"
		},
		{
			"name": "Poland",
			"id": "48",
			"code": "PL"
		},
		{
			"name": "Portugal",
			"id": "351",
			"code": "PT"
		},
		{
			"name": "Puerto Rico",
			"id": "1",
			"code": "PR"
		},
		{
			"name": "Qatar",
			"id": "974",
			"code": "QA"
		},
		{
			"name": "Romania",
			"id": "40",
			"code": "RO"
		},
		{
			"name": "Russia",
			"id": "7",
			"code": "RU"
		},
		{
			"name": "Rwanda",
			"id": "250",
			"code": "RW"
		},
		{
			"name": "Reunion",
			"id": "262",
			"code": "RE"
		},
		{
			"name": "Saint Barthelemy",
			"id": "590",
			"code": "BL"
		},
		{
			"name": "Saint Helena, Ascension and Tristan Da Cunha",
			"id": "290",
			"code": "SH"
		},
		{
			"name": "Saint Kitts and Nevis",
			"id": "1869",
			"code": "KN"
		},
		{
			"name": "Saint Lucia",
			"id": "1758",
			"code": "LC"
		},
		{
			"name": "Saint Martin",
			"id": "590",
			"code": "MF"
		},
		{
			"name": "Saint Pierre and Miquelon",
			"id": "508",
			"code": "PM"
		},
		{
			"name": "Saint Vincent and the Grenadines",
			"id": "1784",
			"code": "VC"
		},
		{
			"name": "Samoa",
			"id": "685",
			"code": "WS"
		},
		{
			"name": "San Marino",
			"id": "378",
			"code": "SM"
		},
		{
			"name": "Sao Tome and Principe",
			"id": "239",
			"code": "ST"
		},
		{
			"name": "Saudi Arabia",
			"id": "966",
			"code": "SA"
		},
		{
			"name": "Senegal",
			"id": "221",
			"code": "SN"
		},
		{
			"name": "Serbia",
			"id": "381",
			"code": "RS"
		},
		{
			"name": "Seychelles",
			"id": "248",
			"code": "SC"
		},
		{
			"name": "Sierra Leone",
			"id": "232",
			"code": "SL"
		},
		{
			"name": "Singapore",
			"id": "65",
			"code": "SG"
		},
		{
			"name": "Slovakia",
			"id": "421",
			"code": "SK"
		},
		{
			"name": "Slovenia",
			"id": "386",
			"code": "SI"
		},
		{
			"name": "Solomon Islands",
			"id": "677",
			"code": "SB"
		},
		{
			"name": "Somalia",
			"id": "252",
			"code": "SO"
		},
		{
			"name": "South Africa",
			"id": "27",
			"code": "ZA"
		},
		{
			"name": "South Sudan",
			"id": "211",
			"code": "SS"
		},
		{
			"name": "South Georgia and the South Sandwich Islands",
			"id": "500",
			"code": "GS"
		},
		{
			"name": "Spain",
			"id": "34",
			"code": "ES"
		},
		{
			"name": "Sri Lanka",
			"id": "94",
			"code": "LK"
		},
		{
			"name": "Sudan",
			"id": "249",
			"code": "SD"
		},
		{
			"name": "Suriname",
			"id": "597",
			"code": "SR"
		},
		{
			"name": "Svalbard and Jan Mayen",
			"id": "47",
			"code": "SJ"
		},
		{
			"name": "Swaziland",
			"id": "268",
			"code": "SZ"
		},
		{
			"name": "Sweden",
			"id": "46",
			"code": "SE"
		},
		{
			"name": "Switzerland",
			"id": "41",
			"code": "CH"
		},
		{
			"name": "Syrian Arab Republic",
			"id": "963",
			"code": "SY"
		},
		{
			"name": "Taiwan",
			"id": "886",
			"code": "TW"
		},
		{
			"name": "Tajikistan",
			"id": "992",
			"code": "TJ"
		},
		{
			"name": "Tanzania, United Republic of Tanzania",
			"id": "255",
			"code": "TZ"
		},
		{
			"name": "Thailand",
			"id": "66",
			"code": "TH"
		},
		{
			"name": "Timor-Leste",
			"id": "670",
			"code": "TL"
		},
		{
			"name": "Togo",
			"id": "228",
			"code": "TG"
		},
		{
			"name": "Tokelau",
			"id": "690",
			"code": "TK"
		},
		{
			"name": "Tonga",
			"id": "676",
			"code": "TO"
		},
		{
			"name": "Trinidad and Tobago",
			"id": "1868",
			"code": "TT"
		},
		{
			"name": "Tunisia",
			"id": "216",
			"code": "TN"
		},
		{
			"name": "Turkey",
			"id": "90",
			"code": "TR"
		},
		{
			"name": "Turkmenistan",
			"id": "993",
			"code": "TM"
		},
		{
			"name": "Turks and Caicos Islands",
			"id": "1649",
			"code": "TC"
		},
		{
			"name": "Tuvalu",
			"id": "688",
			"code": "TV"
		},
		{
			"name": "Uganda",
			"id": "256",
			"code": "UG"
		},
		{
			"name": "Ukraine",
			"id": "380",
			"code": "UA"
		},
		{
			"name": "United Arab Emirates",
			"id": "971",
			"code": "AE"
		},
		{
			"name": "United Kingdom",
			"id": "44",
			"code": "GB"
		},
		{
			"name": "United States",
			"id": "1",
			"code": "US"
		},
		{
			"name": "Uruguay",
			"id": "598",
			"code": "UY"
		},
		{
			"name": "Uzbekistan",
			"id": "998",
			"code": "UZ"
		},
		{
			"name": "Vanuatu",
			"id": "678",
			"code": "VU"
		},
		{
			"name": "Venezuela, Bolivarian Republic of Venezuela",
			"id": "58",
			"code": "VE"
		},
		{
			"name": "Vietnam",
			"id": "84",
			"code": "VN"
		},
		{
			"name": "Virgin Islands, British",
			"id": "1284",
			"code": "VG"
		},
		{
			"name": "Virgin Islands, U.S.",
			"id": "1340",
			"code": "VI"
		},
		{
			"name": "Wallis and Futuna",
			"id": "681",
			"code": "WF"
		},
		{
			"name": "Yemen",
			"id": "967",
			"code": "YE"
		},
		{
			"name": "Zambia",
			"id": "260",
			"code": "ZM"
		},
		{
			"name": "Zimbabwe",
			"id": "263",
			"code": "ZW"
		}
	]
}

export const getInitialRange = (type, startDate, endDate) => {

	let start, end
	switch (type) {
		case 'today':
			start = moment().startOf('day')
			end = moment.max(moment()).endOf('day')
			break;
		case 'tomorrow':
			start = moment().add(1, 'days').startOf('day')
			end = moment.max(moment().add(1, 'days')).endOf('day')
			break;
		case 'yesterday':
			start = moment().subtract(1, 'days').startOf('day')
			end = moment.max(moment().subtract(1, 'days')).endOf('day')
			break;
		case 'last24hours':
			start = moment().subtract(24, 'hours').startOf('day')
			end = moment.max(moment()).endOf('day')
			break;
		case 'week':
			start = moment().startOf('isoWeek');
			end = moment().endOf('isoWeek');
			break;
		case 'lastWeek':
			start = moment().day(-7).startOf('day')
			end = moment().day(-1).endOf('day')
			break;
		case 'last7days':
			start = moment().subtract(7, 'days').startOf('day')
			end = moment.max(moment()).endOf('day')
			break;
		case 'last15days':
			start = moment().subtract(15, 'days').startOf('day')
			end = moment.max(moment()).endOf('day')
			break;
		case 'thisMonth':
			start = moment().startOf('month')
			end = moment().endOf('month');
			break;
		case 'last30Days':
			start = moment().subtract(30, 'days').startOf('day')
			end = moment.max(moment()).endOf('day')
			break;
		case 'last90Days':
			start = moment().subtract(90, 'days').startOf('day')
			end = moment.max(moment()).endOf('day')
			break;
		case 'lastMonth':
			start = moment(moment()).subtract(1, 'months').startOf('month')
			end = moment(moment()).subtract(1, 'months').endOf('month')
			break;
		case 'quarter':
			start = moment().startOf('quarter')
			end = moment().endOf('quarter');
			break;
		case 'last3month':
			start = moment().subtract(3, 'months').startOf('day')
			end = moment.max(moment()).endOf('day')
			break;
		case 'lastQuarter':
			const quarter = moment().quarter();
			start = moment().quarter(quarter - 1).startOf('quarter')
			end = moment().quarter(quarter - 1).endOf('quarter')
			break;
		case 'next7days':
			start = moment().startOf('day')
			end = moment.max(moment().add(7, 'days')).endOf('day')
			break;
		case 'next15days':
			start = moment().startOf('day')
			end = moment.max(moment().add(15, 'days')).endOf('day')
			break;
		case 'nextMonth':
			start = moment(moment()).add(1, 'months').startOf('month')
			end = moment(moment()).add(1, 'months').endOf('month')
			break;
		case 'next30Days':
			start = moment().startOf('day')
			end = moment.max(moment().add(30, 'days')).endOf('day')
			break;
		case 'next90Days':
			start = moment().startOf('day')
			end = moment.max(moment().add(90, 'days')).endOf('day')
			break;
		case "custom":
			start = startDate ? moment(startDate) : moment().startOf('month')
			end = endDate ? moment(endDate) : moment().endOf('month');
			break;
		default:
			start = moment().startOf('month').toDate()
			end = moment.max(moment()).toDate()
			break;
	}

	return {
		start,
		end
	}
}

export const completeColumns = (base, partial) => {
	/* const partialKeys = partial.map(item => item.key);
	const result = [...partial];

	for (let i = 0; i < base.length; i++) {
		const baseItem = base[i];
		if (!partialKeys.includes(baseItem.key)) {
			let inserted = false;
			for (let j = 0; j < result.length; j++) {
				const partialResultItem = result[j];
				const baseIndexPartial = base.findIndex(b => b.key === partialResultItem.key);
				if (baseIndexPartial > i) {
					result.splice(j, 0, baseItem);
					inserted = true;
					break;
				}
			}
			if (!inserted) {
				result.push(baseItem);
			}
		}
	}

	return result; */

	const partialKeys = partial.map(item => item.key);
	let result = [...partial];

	for (let i = 0; i < base.length; i++) {
		const baseItem = base[i];

		if (!partialKeys.includes(baseItem.key)) {
			// El elemento de base no está en partial
			let inserted = false;
			let baseTrueShowIndex = -1;
			for (let k = 0; k < base.length; k++) {
				if (base[k].show) {
					baseTrueShowIndex++;
					if (base[k].key === baseItem.key) {
						break;
					}
				}
			}

			let partialTrueShowIndex = -1;
			for (let j = 0; j < result.length; j++) {
				const partialResultItem = result[j];
				const basePartialItem = base.find(b => b.key === partialResultItem.key);
				if (basePartialItem?.show) {
					partialTrueShowIndex++;
					let basePartialTrueShowIndex = base.findIndex(b => b.show && b.key === basePartialItem.key);

					// Encontrar la posición relativa basada en elementos con show: true
					let currentIndexBaseTrueShow = -1;
					let baseCurrentIndexTrueShow = -1;
					for (let m = 0; m < base.length; m++) {
						if (base[m].show) {
							baseCurrentIndexTrueShow++;
							if (base[m].key === baseItem.key) {
								currentIndexBaseTrueShow = baseCurrentIndexTrueShow;
							}
							if (base[m].key === partialResultItem.key) {
								basePartialTrueShowIndex = baseCurrentIndexTrueShow;
							}
						}
					}

					if (currentIndexBaseTrueShow < basePartialTrueShowIndex) {
						result.splice(j, 0, baseItem);
						inserted = true;
						break;
					}
				}
			}
			if (!inserted) {
				result.push(baseItem);
			}
		}
	}

	return result;
}

export const splitTextIntoLines = (text, maxLength) => {
	let result = "";
	for (let i = 0; i < text.length; i += maxLength) {
		result += text.slice(i, i + maxLength) + "\n";
	}
	return result.trim();
};

// The password must contain at least 1 lowercase alphabetical character, 1 uppercase alphabetical character, 1 numeric character, 1 special character, spaces are not allowed and must be 6 characters or longer (20)
export const validateStrongPassword = (password) => {
	const strongPassword = new RegExp('^(?!.* )(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,20})');
	return strongPassword.test(password)
}

export const dateWithRelativeDays = (dateString, messages) => {
	const givenDate = moment(dateString);
	const today = moment().endOf('day');

	const diff = givenDate.diff(today, 'days');
	let relativeText = diff === 0
		? `(${messages['date_today']})`
		: diff > 0
			? `(${diff} ${messages['days_away']})`
			: `(${Math.abs(diff)} ${messages['days_ago']})`;

	return relativeText;
}

/**
 * Cleans a string by removing emojis and disallowed special characters.
 *
 * This function is useful for sanitizing user input by:
 *  - Removing emojis (based on common Unicode ranges)
 *  - Removing special characters except for:
 *    - Letters (a–z, A–Z)
 *    - Numbers (0–9)
 *    - Hyphens (-)
 *    - Underscores (_)
 *    - Spaces ( )
 *    - Special characters: ! @ # $ % ^ & * ( ) _ + = { } [ ] | : ; ' < > , . ? / -
 *
 * @param {string} str - The original input string to be cleaned.
 * @returns {string} - A sanitized version of the input string, free of emojis and unwanted characters.
 *
 * @example
 * cleanString("Hello! 😊#123_abc-") // "Hello! #123_abc-"
 */
export const cleanString = (str) => {
	// Remove emojis and decorative symbols, allow Latin letters, numbers, spaces, special characters, and hyphens
	if (!str) return '';
	// First, remove emojis and decorative symbols (comprehensive emoji ranges)
	const noEmojis = str.replace(
		/([\u2700-\u27BF]|[\uE000-\uF8FF]|\u24C2|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDDFF]|[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{1F900}-\u{1F9FF}])/gu,
		""
	);
	// Then remove any character that is not a Latin letter, number, space, hyphen, or allowed special character
	// Allowed special characters: ! @ # $ % ^ & * ( ) _ + = { } [ ] | : ; ' < > , . ? / -
	const cleaned = noEmojis.replace(/[^A-Za-z0-9 !@#$%^&*()_+={}[\]|:;'<>,.?/\-]/g, '');
	// Remove leading spaces
	return cleaned.trimStart();

}

/**
 * Cleans a license plate string by removing emojis and disallowed characters.
 * 
 * This function is specifically designed for license plates and allows only:
 *  - Letters (a–z, A–Z)
 *  - Numbers (0–9)
 *  - Hyphens (-)
 *  - Spaces ( )
 *
 * @param {string} str - The license plate string to be cleaned.
 * @returns {string} - A sanitized license plate string.
 *
 * @example
 * cleanLicensePlate("ABC-123. ") // "ABC-123"
 */
export const cleanLicensePlate = (str) => {
	if (!str) return '';
	// Remove emojis and decorative symbols
	const noEmojis = str.replace(
		/([\u2700-\u27BF]|[\uE000-\uF8FF]|\u24C2|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDDFF]|[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{1F900}-\u{1F9FF}])/gu,
		""
	);
	// Allow only letters, numbers, hyphens, and spaces
	const cleaned = noEmojis.replace(/[^A-Za-z0-9 \-]/g, '');
	// Remove leading and trailing spaces
	return cleaned.trim();
}


export const vinValidation = (vin) => {
	// If VIN is null or undefined, return false
	if (!vin) {
		return false;
	}

	// Convert VIN to uppercase
	vin = vin.toUpperCase();

	const vinRegex = /^[A-HJ-NPR-Z\d]{8}[\dX][A-HJ-NPR-Z\d]{8}$/g;

	// If VIN fails regex, return false
	if (!vinRegex.test(vin)) {
		return false;
	}

	// Convert VIN to string of characters
	const vinArray = [...vin];

	// Define weighting factors and transliteration table
	const factors = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
	const table = {
		A: 1,
		B: 2,
		C: 3,
		D: 4,
		E: 5,
		F: 6,
		G: 7,
		H: 8,
		J: 1,
		K: 2,
		L: 3,
		M: 4,
		N: 5,
		P: 7,
		R: 9,
		S: 2,
		T: 3,
		U: 4,
		V: 5,
		W: 6,
		X: 7,
		Y: 8,
		Z: 9,
		0: 0,
		1: 1,
		2: 2,
		3: 3,
		4: 4,
		5: 5,
		6: 6,
		7: 7,
		8: 8,
		9: 9,
	};

	// Get check digit at ninth position
	const check = vin.charAt(8);

	// Calculate the sum of transliterated digits
	const sum = vinArray
		.map((c, i) => table[c] * factors[i])
		.reduce((a, c) => a + c);

	// Calculate remainder, and convert to string
	const remainder = sum % 11;
	const calculatedCheck = remainder.toString();

	// Check whether check digit matches
	const isValid =
		check === 'X' ? calculatedCheck === '10' : calculatedCheck === check;

	return isValid;
};

/**
 * Converts presigned URL images to base64 for PDF generation.
 * Uses multiple strategies with fallback to placeholder.
 * 
 * @param {string} imageUrl - The presigned URL of the image
 * @param {number} maxWidth - Maximum width for the image (default: 100)
 * @param {number} maxHeight - Maximum height for the image (default: 100)
 * @returns {Promise<Object>} - Promise that resolves to image data or placeholder
 */
export const convertImageToBase64ForPDF = async (imageUrl, maxWidth = 100, maxHeight = 100) => {
	// Helper to convert blob/image to high-quality canvas
	const processImage = (img, width, height) => {
		const canvas = document.createElement('canvas');
		const ctx = canvas.getContext('2d');
		const scale = 2;

		canvas.width = width * scale;
		canvas.height = height * scale;
		ctx.scale(scale, scale);
		ctx.imageSmoothingEnabled = true;
		ctx.imageSmoothingQuality = 'high';
		ctx.drawImage(img, 0, 0, width, height);

		return canvas.toDataURL('image/png', 0.95);
	};

	// Helper to handle image loading
	const loadFromBlob = (blob) => new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			const img = new Image();
			img.onload = () => {
				const { width, height } = calculateImageSize(
					img.naturalWidth || img.width,
					img.naturalHeight || img.height,
					maxWidth,
					maxHeight
				);
				resolve({
					dataUrl: processImage(img, width, height),
					width,
					height,
					isRealImage: true
				});
			};
			img.onerror = () => reject(new Error('Image load failed'));
			img.src = reader.result;
		};
		reader.onerror = () => reject(new Error('Blob read failed'));
		reader.readAsDataURL(blob);
	});

	// Strategy 1: XMLHttpRequest
	try {
		const xhr = new XMLHttpRequest();
		xhr.open('GET', imageUrl, true);
		xhr.responseType = 'blob';
		xhr.setRequestHeader('Accept', 'image/*,*/*;q=0.8');
		xhr.setRequestHeader('Cache-Control', 'no-cache');

		const xhrResult = await new Promise((resolve, reject) => {
			xhr.onload = () => {
				if (xhr.status === 200) {
					resolve(xhr.response);
				} else {
					reject(new Error(`XHR failed: ${xhr.status}`));
				}
			};
			xhr.onerror = () => reject(new Error('XHR request failed'));
			xhr.send();
		});

		return await loadFromBlob(xhrResult);
	} catch (error) {
		// Continue to next strategy
	}

	// Fallback: Placeholder
	return {
		isPlaceholder: true,
		width: Math.min(maxWidth, 150),
		height: 40,
		imageUrl: imageUrl,
		originalUrl: imageUrl
	};
};

/**
 * Calculates proportional image dimensions while maintaining aspect ratio
 * 
 * @param {number} originalWidth - Original image width
 * @param {number} originalHeight - Original image height  
 * @param {number} maxWidth - Maximum allowed width
 * @param {number} maxHeight - Maximum allowed height
 * @returns {Object} - Object with calculated width and height
 */
export const calculateImageSize = (originalWidth, originalHeight, maxWidth, maxHeight) => {
	let width = originalWidth;
	let height = originalHeight;

	// If image is smaller than max dimensions, keep original size for better quality
	if (width <= maxWidth && height <= maxHeight) {
		return {
			width: Math.round(width),
			height: Math.round(height)
		};
	}

	// If image is larger than max dimensions, scale it down proportionally
	const aspectRatio = width / height;

	if (width > height) {
		// Landscape orientation - limit by width
		width = Math.min(width, maxWidth);
		height = width / aspectRatio;

		// If height is still too large, limit by height
		if (height > maxHeight) {
			height = maxHeight;
			width = height * aspectRatio;
		}
	} else {
		// Portrait orientation - limit by height
		height = Math.min(height, maxHeight);
		width = height * aspectRatio;

		// If width is still too large, limit by width
		if (width > maxWidth) {
			width = maxWidth;
			height = width / aspectRatio;
		}
	}

	return {
		width: Math.round(width),
		height: Math.round(height)
	};
};

// Generador dinámico de colores
const generateColor = () => {
	const hex = Math.floor(Math.random() * 0xffffff) // número entre 0 y 16777215
		.toString(16) // convierto a base 16
		.padStart(6, "0"); // aseguro que tenga siempre 6 dígitos
	return `#${hex}`;
}

// Ejemplo: generar 30 colores dinámicos
export const generateColorPalette = (size = 20) => {
	const palette = [];
	for (let i = 0; i < size; i++) {
		palette.push(generateColor());
	}
	return palette;

}

// Agrega esta función helper antes de los thunks (después de las importaciones):

/**
 * Merge new items with existing items in an array
 * @param {Array} existingItems - Current items in state
 * @param {Array} newItems - New items to add or update
 * @param {string} sortByKey - Optional key to sort by (e.g., 'name', 'label')
 * @returns {Array} Merged and optionally sorted array
 */
export const mergeAndSortItems = (existingItems = [], newItems = [], sortByKey = null) => {
    // Create a copy to avoid mutation
    let items = [...existingItems];
    
    // Merge new items with existing ones
    newItems.forEach(newItem => {
        let existingIndex = items.findIndex(item => item.id === newItem.id);
        if (existingIndex !== -1) {
            // Update existing item with new data
            items[existingIndex] = { ...items[existingIndex], ...newItem };
        } else {
            // Add new item if it doesn't exist
            items.push(newItem);
        }
    });
    
    // Sort alphabetically if sortByKey is provided
    if (sortByKey) {
        items.sort((a, b) => {
            const valueA = (a[sortByKey] || '').toLowerCase();
            const valueB = (b[sortByKey] || '').toLowerCase();
            return valueA.localeCompare(valueB);
        });
    }
    
    return items || [];
};

/**
 * Fetches route information (ETA and distance) between two points using Google Maps Directions API.
 * @param {Object} startPoint - The starting point with latitude and longitude.
 * @param {Object} endPoint - The ending point with latitude and longitude.
 */
export const getRouteInfo = (startPoint, endPoint, { isKph, messages, onResult }) => {
	if (!window.google?.maps) return;
	const directionsService = new google.maps.DirectionsService();
	const origin = {
		lat: parseFloat(startPoint?.latitude || 0),
		lng: parseFloat(startPoint?.longitude || 0)
	};
	const destination = {
		lat: parseFloat(endPoint?.latitude || 0),
		lng: parseFloat(endPoint?.longitude || 0)
	};
	directionsService.route(
		{ origin, destination, travelMode: google.maps.TravelMode.DRIVING },
		(result, status) => {
			if (status === google.maps.DirectionsStatus.OK) {
				const valueTime = convertSecondsToTime(result.routes[0].legs[0].duration.value || 0);
				const etaText = [
					valueTime?.days > 0 ? `${valueTime.days} ${valueTime.days === 1 ? messages['Day'] || 'Day' : messages['Days'] || 'Days'}` : '',
					valueTime?.hour > 0 ? `${valueTime.hour} ${valueTime.hour === 1 ? messages['hour'] || 'hour' : messages['hours'] || 'hours'}` : '',
					valueTime?.min > 0 ? `${valueTime.min} ${valueTime.min === 1 ? messages['min'] || 'min' : messages['mins'] || 'mins'}` : '',
				].filter(Boolean).join(' ');
				const distanceMeters = result.routes[0].legs[0].distance?.value || 0;
				const distText = isKph
					? `${(distanceMeters / 1000).toFixed(1)} ${messages['kilometers'] || 'km'}`
					: `${(distanceMeters / 1609.344).toFixed(1)} ${messages['miles'] || 'mi'}`;
				onResult({ eta: etaText, distance: distText });
			}
		}
	);
};

/**
 * Applies an array of filters to a list of items.
 * Each filter should have a 'field' (dot-separated path) and a 'value' to match.
 * Only items that match all filters will be included in the result.
 * @param {Array} list - The array of items to filter.
 * @param {Array} filters - The array of filter objects, each with 'field' and 'value'.
 * @returns {Array} - The filtered array of items.
 */
export const applyFiltersToList = (list, filters) => {
	if (!filters?.length) return list;

	// Helper function to get nested value from an object using a dot-separated path
	const getNestedValue = (obj, path) =>
		path?.split('.').reduce((acc, key) => acc?.[key], obj);

	return filters.reduce(
		(filtered, filter) =>
			filter?.value != null
				? filtered?.filter(
					(item) => getNestedValue(item, filter.field) === filter.value
				)
				: filtered,
		list
	);
};